import { AnimatedChevron, IconSize } from '@ardoq/icons';
import { UnstyledButton } from '@ardoq/button';
import styled from 'styled-components';
import { Header5 } from '@ardoq/typography';
import { FlexBox } from '@ardoq/layout';
import { colors } from '@ardoq/design-tokens';
import { t, type I18nLocale } from '@ardoq/i18n';

type ToggleTriplesIslandHeaderProps = {
  label: string;
  onToggle: () => void;
  isExpanded: boolean;
  i18nLocale: I18nLocale;
};

export const CustomClosableIslandHeader = ({
  label,
  onToggle,
  isExpanded,
  i18nLocale,
}: ToggleTriplesIslandHeaderProps) => {
  return (
    <UnstyledButton onClick={onToggle} style={{ cursor: 'pointer' }}>
      <FlexBox
        align="center"
        justify="space-between"
        paddingX="medium"
        paddingY="small"
      >
        <Header5 color="textModerate">{label}</Header5>
        <MockedGhostButton
          data-tooltip-text={
            isExpanded
              ? t(
                  i18nLocale,
                  'viewpointBuilder:islandHeader.collapse',
                  'Collapse'
                )
              : t(i18nLocale, 'viewpointBuilder:islandHeader.expand', 'Expand')
          }
        >
          <AnimatedChevron $isUp={isExpanded} iconSize={IconSize.MEDIUM} />
        </MockedGhostButton>
      </FlexBox>
    </UnstyledButton>
  );
};

const MockedGhostButton = styled(FlexBox).attrs({
  padding: 'xsmall',
  align: 'center',
  justify: 'center',
})`
  border-radius: 6px; /** Mimics GhostButton border-radius */
  min-height: 34px; /** Mimics GhostButton size */
  min-width: 34px; /** Mimics GhostButton size */

  &:hover {
    background-color: ${colors.surfaceActionGhostHover};
  }
`;
